module.exports = __webpack_public_path__ + "static/don22-3ea1bd634a337d8aaec8d1819f40fd1c.jpg";